// Auto-generated CalVer version from build time (YYYY.MM.DD-hash)
// No manual updates needed — every build gets a unique version.
const buildDate = import.meta.env.VITE_BUILD_DATE || "dev";
const buildHash = import.meta.env.VITE_BUILD_HASH || "000000";

export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "dev";
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
export const APP_BUILD_DATE = buildDate;
export const APP_BUILD_HASH = buildHash;
